/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { TicketListRow, type TicketListRowGroup } from '../../shared/ticket/TicketListRow';
import type { PriceList } from '../domain/priceListTypes';

type Props = {
  list: PriceList;
  onPress?: () => void;
  group?: TicketListRowGroup;
  /** Cantidad de productos con precio en la lista. */
  itemCount?: number;
};

export function PriceListRowCard({ list, onPress, group = 'solo', itemCount }: Props) {
  const modeLabel = list.pricingMode === 'percent_off_base' ? '% sobre base' : 'Precio fijo';
  const meta = itemCount != null ? `${modeLabel} · ${itemCount} prod.` : modeLabel;
  return (
    <TicketListRow
      title={list.name}
      subtitle={list.code ? `Código ${list.code}` : null}
      meta={meta}
      chipLabel={list.appliesOnline ? 'Tienda online' : list.isDefault ? 'Por defecto' : null}
      statusLabel={list.isActive ? null : 'Inactiva'}
      statusTone={list.isActive ? 'ok' : 'muted'}
      inactive={!list.isActive}
      showChevron={Boolean(onPress)}
      onPress={onPress}
      group={group}
      accessibilityLabel={list.name}
    />
  );
}
